export default __webpack_public_path__ + "static/Tallahassee_AdobeStock_249931993-6e5d74d5570a9c895b3ddedc54937eeb.jpeg";